// Whether anything in a grid's current rows resolved a business unit name.
//
// A tenant whose ServiceTitan token predates the business-units scope has no rows in
// tblBusinessUnit at all, so the views resolve no name for any of its records (US-230). That is
// the majority of tenants today, and showing them a column that is blank on every row reads as a
// new defect rather than as "you have no business units" -- so both grids hide the column outright
// when nothing in the list resolved.
//
// Derived from the rows rather than from the selected tenant on purpose: ToDoHome and the admin
// Overview render these grids with no tenant prop at all, so a tenant-derived flag would hide the
// column from exactly the people who asked for it.
//
// Shared rather than inlined per grid because it is a business rule, not styling: the two grids
// apply it through different mechanisms (a columnVisibilityModel entry vs a conditional splice,
// each matching its own file's existing convention), and only the predicate itself has to agree.
export const hasBusinessUnitData = (rows) =>
  rows.some((row) => row.businessUnitName);
